export default {
  props: {
    isExamComplete: {
      type: Boolean,
      default: false
    },
    exam: {
      type: String,
      default: ''
    },
    isPractice: {
      type: Boolean,
      default: false
    },
    trial: {
      type: Object,
      default: () => {}
    },
    phase: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 0
    },
    displayType: {
      type: String,
      default: ''
    }
  }
}
